import { AppProblemModel } from '@/services/api/AppProblemModel'
import { handleHttpError } from '@/composables/http/handleHttpError'

export default defineNuxtPlugin(() => {
  globalThis.$fetch = $fetch.create({
    onResponseError({ response }) {
      const problem = AppProblemModel.normalize({ response })

      if (
        problem.code === 'AUTHENTICATION_REQUIRED' ||
        problem.code === 'AUTHORIZATION_DENIED' ||
        problem.code === 'RESOURCE_NOT_FOUND' ||
        problem.status === 401 ||
        problem.status === 403 ||
        problem.status === 404
      ) {
        void handleHttpError(problem)
      }
    }
  })
})
